// extracted by mini-css-extract-plugin
module.exports = {"reviewItem":"ReviewItem_reviewItem__6LbPw","icon":"ReviewItem_icon__bZLSt"};